var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 1024 1024",
    height: "1024px",
    id: "Instagram_2_",
    viewBox: "0 0 1024 1024",
    width: "1024px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.094,306.009c0-27.5,19.413-61.375,43.14-75.277L468.861,25.286    c23.727-13.902,62.553-13.902,86.28,0l350.625,205.445c23.729,13.902,43.141,47.777,43.141,75.277v412    c0,27.5-19.412,61.375-43.141,75.277L555.141,998.731c-23.727,13.901-62.553,13.901-86.28,0L118.234,793.286    c-23.727-13.902-43.14-47.777-43.14-75.277V306.009z",
    fill: "#ffffff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M938.092,262.262c0,0-1.043-2.021-3.287-5.308   c-1.818-2.664-3.746-5.561-6.111-8.186c-5-5.546-6.697-6.941-7.377-7.551c-2.637-2.355-5.848-4.801-8.945-6.617   c-2.26-1.325-362.889-212.631-362.889-212.631s-6.123-3.544-11.67-5.321c-5.547-1.778-9.457-2.56-13.51-3.129   s-9.672-0.854-13.297-0.854c-3.627,0-12.089,0.711-15.716,1.565c-3.627,0.853-6.276,1.511-7.236,1.831s-3.173,1.093-4.08,1.387   c-0.907,0.293-5.094,2.16-5.333,2.293c-0.239,0.133-1.643,0.776-2.431,1.238S124.594,227.004,124.594,227.004   s-14.797,8.097-20.628,13.074c-2.497,2.131-5.266,4.867-7.658,7.582c-3.196,3.627-5.807,7.203-7.026,9.093   c-0.923,1.43-2.28,3.533-3.494,5.707c-1.577,2.825-3.032,5.837-3.667,7.147c-1.162,2.398-3.293,8.053-3.827,9.76   s-1.547,5.534-1.707,6.436c-0.042,0.234-0.693,3.521-0.747,3.911c-0.053,0.391-0.44,2.92-0.533,4.267   c-0.033,0.48-0.211,2.897-0.212,2.969c-0.001,0.072-0.001,429.511-0.001,429.511s0.349,5.079,0.427,5.636   c0.028,0.202,0.453,3.432,0.782,4.836c0.213,0.91,0.64,2.986,0.924,3.982c0.284,0.996,0.729,2.636,0.96,3.342   c0.213,0.652,0.96,2.916,1.209,3.591c0.249,0.677,1.25,3.248,1.529,3.911c0.286,0.682,1.813,4.019,1.92,4.231   C82.951,756.204,938.092,262.262,938.092,262.262z",
    enableBackground: "new    ",
    fill: "#FFFFFF",
    opacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Instagram"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 637.239,
    cy: 386.196,
    fill: "#FFFFFF",
    r: 28.276
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512.001,
    cy: 512.009,
    fill: "none",
    r: 103.605,
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    strokeWidth: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.933,573.574c0,91.127,73.873,165,165,165   h102.136c91.127,0,165-73.873,165-165v-123.13c0-91.127-73.873-165-165-165H460.933c-91.127,0-165,73.873-165,165V573.574z",
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    strokeWidth: 45
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJInstagramIcon);
export default __webpack_public_path__ + "static/media/j-instagram-icon.26d86a947153756352988f9d067210e5.svg";
export { ForwardRef as ReactComponent };